// extracted by mini-css-extract-plugin
module.exports =  {"popup-link":"_93444fe79c--popup-link--S_Cdn"};